/**
 * Campos configuráveis do formulário de ideias
 */
export const CAMPOS_CONFIGURAVEIS_IDEIA = [
  "setores",
  "objetivo",
  "comoAtingirObjetivo",
  "descricaoProblema",
  "diferenciais",
  "feedback",
  "participantesReferences",
  "anexos"
] as const;

/**
 * Type para os campos configuráveis
 */
export type TCampoConfiguravelIdeia = (typeof CAMPOS_CONFIGURAVEIS_IDEIA)[number];

/**
 * Configuração de um campo individual do formulário
 */
export interface TConfiguracaoCampoIdeia {
  /**
   * Define se o campo será visível no formulário
   */
  visivel: boolean;
  /**
   * Título customizado para o campo
   */
  titulo: string;
}

/**
 * Configuração completa do formulário de ideias
 * Map onde a chave é o nome do campo e o valor é a configuração
 */
export type TConfiguracaoFormularioIdeias = {
  [K in TCampoConfiguravelIdeia]: TConfiguracaoCampoIdeia;
} & {
  /**
   * Lista de objetivos customizados para o formulário de ideias
   */
  objetivos?: string[];
};

/**
 * Documento do Firestore para configuração do formulário
 */
export interface TConfiguracaoFormularioIdeiasDocument extends TConfiguracaoFormularioIdeias {
  updatedAt?: Date;
  updatedBy?: string;
}
